<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Bônus Linear</h5>
                <p class="mb-0 text-sm">Bônus de equipe — pontos por cadastros em níveis 2 em diante</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <span class="badge bg-gradient-warning text-sm">
                  <i class="fas fa-hard-hat me-1"></i>
                  Em desenvolvimento
                </span>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="em-construcao">
              <div class="icone-construcao bg-gradient-success">
                <i class="fas fa-tools"></i>
              </div>

              <h4 class="mt-4 mb-2">Página em construção</h4>
              <p class="text-sm text-secondary mb-4 text-center">
                Esta seção será liberada junto com o <strong>módulo financeiro</strong>,
                quando as comissões em dinheiro estiverem ativas.
              </p>

              <div class="card-preview">
                <h6 class="text-uppercase text-xs text-secondary mb-3">Previsto nesta tela</h6>
                <ul class="lista-features">
                  <li><i class="fas fa-check-circle text-success me-2"></i>Total de bônus lineares acumulado</li>
                  <li><i class="fas fa-check-circle text-success me-2"></i>Distribuição de pontos por nível (2 a 10)</li>
                  <li><i class="fas fa-check-circle text-success me-2"></i>Conversão de pontos em R$ por competência</li>
                  <li><i class="fas fa-check-circle text-success me-2"></i>Ranking da sua equipe (membros mais produtivos)</li>
                </ul>
              </div>

              <div class="mt-4 text-center">
                <router-link to="/afiliados/rede-estruturada" class="btn bg-gradient-primary btn-sm">
                  <i class="fas fa-arrow-left me-1"></i>
                  Voltar para Rede Estruturada
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.em-construcao {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
}
.icone-construcao {
  width: 90px;
  height: 90px;
  border-radius: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.4rem;
  box-shadow: 0 8px 24px rgba(72, 187, 120, 0.25);
}

.card-preview {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px 24px;
  max-width: 480px;
  width: 100%;
  border: 1px solid #e9ecef;
}

.lista-features {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.88rem;
  color: #344767;
}
.lista-features li {
  padding: 6px 0;
  border-bottom: 1px dashed #e9ecef;
}
.lista-features li:last-child {
  border-bottom: none;
}
</style>
